module.exports = __webpack_public_path__ + "media/images/hot-9a16f24f063b860dce64da6e48f13560.png";